import maCartDamagesModal from '../cartModal/cartModal'
import maEventBus from '@/components/eventbus/index.js'
import { mapState, mapActions } from 'vuex'
import { USER_MODULE_NAME } from '@/modules/User/store/types'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_SINISTER_SUMMARY
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import userFlowMixin from '@/modules/User/mixins/userFlowMixin'

export default {
  name: 'navBar',

  mixins: [userFlowMixin, flowMixin],

  components: {
    maCartDamagesModal
  },

  data: function () {
    return {
      modalCartIsVisible: false,
      damageDetailsView: false,
      logoActive: null
    }
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterSummary: 'sinisterSummary'
    }),
    ...mapState(USER_MODULE_NAME, {
      stateUserRole: 'userRole'
    }),

    isFixedNavbar() {
      return false
    },

    cartIsVisible() {
      return this.stateWarrantySinisterSummary.length >= 1
    },

    getLogoWidth() {
      switch (this.logoActive) {
        case 'allianz':
          return '34'
        case 'logoMa':
          return '56'
        default:
          return null
      }
    },

    getLogoHeight() {
      switch (this.logoActive) {
        case 'allianz':
          return '34'
        case 'logoMa':
          return '23'
        default:
          return null
      }
    },
    getLogoUrl() {
      return this.getFlowCompanyIcon
    },
    getCompanyColor() {
      return this.getFlowCompanyColor
    }
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetSinisterSummary: WARRANTY_GET_SINISTER_SUMMARY
    }),
    /**
     * @function
     * @name handleClickGoToHome
     * @description Pushes the params for the home view
     */
    handleClickGoToHome() {
      const user = this.$route.params.user
      this.$router
        .push({ name: 'claim-home', params: { user } })
        .catch((e) => {})
    },
    setStyleBody() {
      if (this.modalCartIsVisible) {
        document.querySelector('body').style.overflow = 'hidden'
      } else {
        document.querySelector('body').style.overflow = 'visible'
      }
    },
    handleToggleModal() {
      this.modalCartIsVisible = !this.modalCartIsVisible
      this.setStyleBody()
    },

    handleLogo() {
      if (this.isBillmaAgentUser) {
        this.logoActive = 'allianz'
      } else if (this.isBillmaInsuredUser) {
        this.logoActive = 'allianz'
      } else if (
        this.isProfessionalUser ||
        this.isRenInsuredUser ||
        this.isRenProfessionalUser ||
        this.isInsuredUser
      ) {
        this.logoActive = 'logoMa'
      } else {
        this.logoActive = null
      }
    }
  },

  /**
   * If there is mavAuth in local storage it will get the damages added(stateWarrantySinisterSummary) by executing the actWarrantyGetSinisterSummary
   * We check as well if there is role. That means user has been logged correctly.
   */
  mounted() {
    this.handleLogo()
    maEventBus.$on('damageDeleted:cart', () => {
      if (this.stateWarrantySinisterSummary.length === 0) {
        this.modalCartIsVisible = false
      }
    })
  }
}
